<template lang="html">
  <section class="banner-beneficios container row-start">
    <img src="/static/img/fondo-cable2.webp" class="fondo-cable">

    <div class="beneficios">
      <div class="beneficio row-start">
        <span class="tick">
          <img src="/static/img/tick.svg" alt="">
        </span>
        <div class="textos">
          <h3 class="row-start">{{ $t('newSimulador.resultView.bannerBenefits.title') }}</h3>
          <p class="row-start -orange">{{ $t('newSimulador.resultView.bannerBenefits.subtitle') }}</p>
        </div>
      </div>
      <div class="beneficio row-start">
        <span class="tick">
          <img src="/static/img/tick.svg" alt="">
        </span>
        <div class="textos">
          <h3 class="row-start">{{ $t('newSimulador.resultView.bannerBenefits.title2') }}</h3>
          <p class="row-start -orange">{{ $t('newSimulador.resultView.bannerBenefits.subtitle2') }}</p>
        </div>
      </div>
      <div class="beneficio row-start">
        <span class="tick">
          <img src="/static/img/tick.svg" alt="">
        </span>
        <div class="textos">
          <h3 class="row-start">{{ $t('newSimulador.resultView.bannerBenefits.title3') }}</h3>
          <p class="row-start -orange">{{ $t('newSimulador.resultView.bannerBenefits.subtitle3') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="js">
export default {
  name: 'banner-beneficios',
}
</script>

<style scoped lang="scss">
@import '@/assets/css/colors.scss';

.banner-beneficios {
  display: wrap;
  flex-wrap: wrap;
  align-items: center;
  padding: 50px 15px;
}

.beneficios {
  margin-left: 50px;
}

.beneficio {
  display: flex;
  margin-bottom: 30px;

  .tick {
    background: $orange;
    width: 40px;
    height: 40px;
    display: inline-block;
    text-align: center;
    border-radius: 50%;
    margin-right: 30px;
    transform: translateY(-10px);
  }

  .textos {
    max-width: calc(100% - 40px);
    display: flex;
    flex-direction: column;
    justify-content: start;

    h3 {
      margin-bottom: 0;
      font-size: 44px;
    }

    p {
      font-size: 20px;
      font-weight: 700;
    }
  }
}

@media screen and (max-width: 1150px) {
  .fondo-cable {
    max-width: 300px;
  }
  .beneficios {
    margin-left: 0;
  }
}

@media screen and (max-width: 990px) {
  .fondo-cable {
    max-width: 200px;
  }

}

@media screen and (max-width: 890px) {
  .fondo-cable {
    display: none;
  }
  .banner-beneficios {
    justify-content: center;
  }
}

@media screen and (max-width: 767px) {
  .beneficio {
    .textos {
      h3 {
        font-size: 28px;
        text-align: start;
      }
      p {
        font-size: 14px;
        text-align: start;
      }
    } 
    .tick {
      width: 30px;
      height: 30px;
      margin-right: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/banner-beneficios.vue